Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var semanticUiReact = require('semantic-ui-react');
var axios = require('axios');
var Overridable = require('react-overridable');
var _pickBy = require('lodash/pickBy');
var _hasIn = require('lodash/hasIn');
var _isEmpty = require('lodash/isEmpty');
var formik = require('formik');
var _omit = require('lodash/omit');
var _isNumber = require('lodash/isNumber');
var _filter = require('lodash/filter');
var _matches = require('lodash/matches');
var _get = require('lodash/get');
var _debounce = require('lodash/debounce');
var _uniqBy = require('lodash/uniqBy');
var queryString = require('query-string');
var tinymceReact = require('@tinymce/tinymce-react');
require('tinymce/tinymce');
require('tinymce/models/dom/model');
require('tinymce/themes/silver');
require('tinymce/icons/default');
require('tinymce/plugins/table');
require('tinymce/plugins/autoresize');
require('tinymce/plugins/codesample');
require('tinymce/plugins/link');
require('tinymce/plugins/lists');
require('tinymce/plugins/wordcount');
var _isArray = require('lodash/isArray');
var luxon = require('luxon');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var Overridable__default = /*#__PURE__*/_interopDefaultLegacy(Overridable);
var _pickBy__default = /*#__PURE__*/_interopDefaultLegacy(_pickBy);
var _hasIn__default = /*#__PURE__*/_interopDefaultLegacy(_hasIn);
var _isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(_isEmpty);
var _omit__default = /*#__PURE__*/_interopDefaultLegacy(_omit);
var _isNumber__default = /*#__PURE__*/_interopDefaultLegacy(_isNumber);
var _filter__default = /*#__PURE__*/_interopDefaultLegacy(_filter);
var _matches__default = /*#__PURE__*/_interopDefaultLegacy(_matches);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _debounce__default = /*#__PURE__*/_interopDefaultLegacy(_debounce);
var _uniqBy__default = /*#__PURE__*/_interopDefaultLegacy(_uniqBy);
var queryString__default = /*#__PURE__*/_interopDefaultLegacy(queryString);
var _isArray__default = /*#__PURE__*/_interopDefaultLegacy(_isArray);

// This file is part of React-Invenio-Forms
class InvenioPopup extends React.Component {
  render() {
    const {
      popupId,
      size,
      trigger,
      content,
      position,
      inverted,
      ariaLabel,
      hoverable
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      id: popupId,
      size: size,
      position: position,
      inverted: inverted,
      hoverable: hoverable,
      on: ["hover", "focus"],
      trigger: /*#__PURE__*/React__default["default"].cloneElement(trigger, {
        "role": "button",
        "tabIndex": 0,
        "aria-label": ariaLabel
      }),
      content: /*#__PURE__*/React__default["default"].createElement("p", {
        role: "tooltip",
        "aria-live": "polite"
      }, content)
    });
  }
}
InvenioPopup.defaultProps = {
  inverted: false,
  position: "top left",
  size: "small",
  hoverable: true
};

// This file is part of InvenioRDM

/**
 * Primary UI Image component providing a fallback url if src one is not
 * able to be resolved. This is a thin layer on top of the <img> element.
 */
class Image extends React.Component {
  constructor() {
    super(...arguments);
    this.myRef = /*#__PURE__*/React__default["default"].createRef();
    this.setSrc = function (currentTarget, src) {
      let isFallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (isFallback) {
        if (!currentTarget.classList.contains("fallback_image")) {
          currentTarget.className += " fallback_image";
        }
      } else {
        if (currentTarget.classList.contains("fallback_image")) {
          currentTarget.classList.remove("fallback_image");
        }
      }
      if (currentTarget.nodeName !== "IMG") {
        // Item.Image is wrapping the <img> in a div element
        const img = currentTarget.querySelector("img");
        if (!img) {
          throw Error("No img tag found");
        }
        currentTarget = img;
      }
      currentTarget.src = src;
    };
  }
  async componentDidMount() {
    const {
      fallbackSrc,
      loadFallbackFirst,
      src
    } = this.props;
    if (loadFallbackFirst) {
      try {
        await axios__default["default"].get(src);
        this.setSrc(this.myRef.current, src);
      } catch (error) {
        // Fallback image is already loaded
        console.warn(`
        '${src}' couldn't be resolved. '${fallbackSrc}' will be used instead.`);
      }
    }
  }
  render() {
    const {
      alt,
      className,
      src,
      fallbackSrc,
      loadFallbackFirst,
      ...UIprops
    } = this.props;
    const loadingClass = !loadFallbackFirst ? `${className} placeholder` : `${className} fallback_image`;
    const url = loadFallbackFirst ? fallbackSrc : src;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Ref, {
      innerRef: this.myRef
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Image, Object.assign({
      className: loadingClass,
      alt: alt,
      src: url
    }, !loadFallbackFirst && {
      onError: _ref => {
        let {
          currentTarget
        } = _ref;
        currentTarget.onerror = null; // prevents looping
        this.setSrc(currentTarget, fallbackSrc, true);
      },
      onLoad: () => {
        // Control the loader via ref to make it immediately invisible
        if (!loadFallbackFirst) {
          this.myRef.current.classList.remove("placeholder");
        }
      }
    }, UIprops)));
  }
}
Image.defaultProps = {
  className: "",
  alt: "No image found",
  fallbackSrc: "/static/images/square-placeholder.png",
  loadFallbackFirst: false
};

/*
 * // This file is part of React-Invenio-Forms
 * // Copyright (C) 2024 CERN.
 * //
 * // React-Invenio-Forms is free software; you can redistribute it and/or modify it
 * // under the terms of the MIT License; see LICENSE file for more details.
 */
const makeIdEntry = identifier => {
  let icon, link;
  switch (identifier.scheme) {
    case "orcid":
      icon = "/static/images/orcid.svg";
      link = `https://orcid.org/${identifier.identifier}`;
      break;
    case "gnd":
      icon = "/static/images/gnd-icon.svg";
      link = `https://d-nb.info/gnd/${identifier.identifier}`;
      break;
    case "ror": // ROR doesn't recommend displaying ROR IDs
    case "isni":
    case "grid":
      return;
    // Skip these schemes
    default:
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, identifier.scheme, ": ", identifier.identifier);
  }
  return /*#__PURE__*/React__default["default"].createElement("span", {
    key: identifier.identifier
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default["default"].createElement(Image, {
    src: icon,
    className: "inline-id-icon mr-5",
    verticalAlign: "middle"
  }), identifier.scheme === "orcid" && identifier.identifier));
};
const makeSubheader = (creatibutor, isOrganization) => {
  if (isOrganization) {
    var _ref, _ref$filter, _creatibutor$types, _creatibutor$types$ma;
    const locationPart = (_ref = [creatibutor === null || creatibutor === void 0 ? void 0 : creatibutor.location_name, creatibutor === null || creatibutor === void 0 ? void 0 : creatibutor.country_name]) === null || _ref === void 0 ? void 0 : (_ref$filter = _ref.filter(Boolean)) === null || _ref$filter === void 0 ? void 0 : _ref$filter.join(", ");
    const typesPart = creatibutor === null || creatibutor === void 0 ? void 0 : (_creatibutor$types = creatibutor.types) === null || _creatibutor$types === void 0 ? void 0 : (_creatibutor$types$ma = _creatibutor$types.map(type => type.charAt(0).toUpperCase() + type.slice(1))) === null || _creatibutor$types$ma === void 0 ? void 0 : _creatibutor$types$ma.join(", ");
    return `${locationPart || ""}${locationPart && typesPart ? " — " : ""}${typesPart || ""}`.trim();
  } else {
    var _creatibutor$affiliat, _creatibutor$affiliat2;
    return (creatibutor === null || creatibutor === void 0 ? void 0 : (_creatibutor$affiliat = creatibutor.affiliations) === null || _creatibutor$affiliat === void 0 ? void 0 : (_creatibutor$affiliat2 = _creatibutor$affiliat.map(affiliation => {
      var _affiliation$acronym;
      if (((_affiliation$acronym = affiliation.acronym) === null || _affiliation$acronym === void 0 ? void 0 : _affiliation$acronym.length) > 0) {
        return `${affiliation.name} (${affiliation.acronym})`;
      }
      return affiliation.name;
    })) === null || _creatibutor$affiliat2 === void 0 ? void 0 : _creatibutor$affiliat2.join(", ")) || "";
  }
};
const AffiliationsSuggestions = (creatibutors, isOrganization) => {
  const results = creatibutors.map(creatibutor => {
    var _creatibutor$identifi;
    // ensure `affiliations` and `identifiers` are present
    creatibutor.affiliations = creatibutor.affiliations || [];
    creatibutor.identifiers = creatibutor.identifiers || [];
    const subheader = makeSubheader(creatibutor, isOrganization);
    let name = creatibutor.name;
    if (creatibutor.acronym) name += ` (${creatibutor.acronym})`;
    const idString = [];
    (_creatibutor$identifi = creatibutor.identifiers) === null || _creatibutor$identifi === void 0 ? void 0 : _creatibutor$identifi.forEach(i => {
      const idEntry = makeIdEntry(i);
      if (idEntry) idString.push(idEntry);
    });
    return {
      text: creatibutor.name,
      value: creatibutor.id || creatibutor.name,
      name: creatibutor.name,
      extra: creatibutor,
      id: creatibutor.id,
      key: creatibutor.id,
      // Needed by RemoteSelectField to filter out unique values
      content: /*#__PURE__*/React__default["default"].createElement(Overridable__default["default"], {
        id: "ReactInvenioForms.AffiliationsSuggestions.content",
        key: creatibutor.id,
        creatibutor: creatibutor,
        isOrganization: isOrganization,
        idString: idString,
        makeSubheader: makeSubheader,
        makeIdEntry: makeIdEntry
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Header, null, name, " ", idString.length > 0 && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, "(", idString, ")"), subheader.length > 0 && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Header.Subheader, null, subheader)))
    };
  });
  return results;
};

class UserListItemCompact extends React.Component {
  render() {
    const {
      id,
      user,
      linkToDetailView
    } = this.props;
    const name = user.profile.full_name || user.username;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item, {
      className: "flex",
      key: id
    }, /*#__PURE__*/React__default["default"].createElement(Image, {
      src: user.links.avatar,
      avatar: true,
      loadFallbackFirst: true
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Content, {
      className: "ml-10"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Header, {
      className: !user.description ? "mt-5" : ""
    }, linkToDetailView ? /*#__PURE__*/React__default["default"].createElement("a", {
      href: linkToDetailView
    }, /*#__PURE__*/React__default["default"].createElement("b", null, name)) : /*#__PURE__*/React__default["default"].createElement("b", null, name), user.type === "group" && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
      className: "ml-10"
    }, "Group"), user.is_current_user && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
      size: "tiny",
      className: "primary ml-10"
    }, "You")), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Meta, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "truncate-lines-1"
    }, " ", user.profile.affiliations))));
  }
}
UserListItemCompact.defaultProps = {
  linkToDetailView: undefined
};

const BulkActionsContext = /*#__PURE__*/React__default["default"].createContext({
  bulkActionContext: {},
  addToSelected: () => {},
  allSelected: false,
  setAllSelected: () => {},
  selectedCount: 0
});

/*
 * This file is part of Invenio.
 * Copyright (C) 2022 CERN.
 *
 * Invenio is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */
class SearchResultsBulkActions extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnChange = () => {
      const {
        setAllSelected,
        allSelected
      } = this.context;
      this.setState({
        allSelectedChecked: !allSelected
      });
      setAllSelected(!allSelected, true);
    };
    this.handleActionOnChange = (e, _ref) => {
      let {
        value,
        ...props
      } = _ref;
      if (!value) return;
      const {
        optionSelectionCallback
      } = this.props;
      const {
        selectedCount,
        bulkActionContext
      } = this.context;
      const selected = _pickBy__default["default"](bulkActionContext, _ref2 => {
        let {
          selected
        } = _ref2;
        return selected === true;
      });
      optionSelectionCallback(value, selected, selectedCount);
    };
    const {
      allSelected: _allSelected
    } = this.props;
    this.state = {
      allSelectedChecked: _allSelected
    };
  }
  componentDidMount() {
    const {
      allSelected
    } = this.context;
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      allSelectedChecked: allSelected
    });
  }
  render() {
    const {
      bulkDropdownOptions
    } = this.props;
    const {
      allSelectedChecked
    } = this.state;
    const {
      allSelected,
      selectedCount
    } = this.context;
    const noneSelected = selectedCount === 0;
    const dropdownOptions = bulkDropdownOptions.map(_ref3 => {
      let {
        key,
        value,
        text
      } = _ref3;
      return {
        key: key,
        value: value,
        text: text,
        disabled: noneSelected
      };
    });
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Checkbox, {
      className: "align-self-center mr-10",
      onChange: this.handleOnChange,
      checked: allSelectedChecked && allSelected
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
      className: "align-self-center fluid-responsive",
      text: `${selectedCount} members selected`,
      options: dropdownOptions,
      "aria-label": "bulk actions",
      item: true,
      selection: true,
      value: null,
      selectOnBlur: false,
      onChange: this.handleActionOnChange,
      selectOnNavigation: false
    }));
  }
}
SearchResultsBulkActions.contextType = BulkActionsContext;
SearchResultsBulkActions.defaultProps = {
  allSelected: false
};

class SearchResultsBulkActionsManager extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.addToSelected = (rowId, data) => {
      const {
        selectedCount
      } = this.state;
      if (_hasIn__default["default"](this.selected, `${rowId}`)) {
        this.selected[rowId].selected = !this.selected[rowId].selected;
      } else {
        this.selected[rowId].selected = true;
        this.selected[rowId].data = data;
      }
      if (!this.selected[rowId].selected) {
        this.setAllSelected(false);
        this.setSelectedCount(selectedCount - 1);
      } else {
        const updatedCount = selectedCount + 1;
        this.setSelectedCount(updatedCount);
        if (Object.keys(this.selected).length === updatedCount) {
          this.setAllSelected(true);
        }
      }
    };
    this.setSelectedCount = count => {
      this.setState({
        selectedCount: count
      });
    };
    this.setAllSelected = function (val) {
      let global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      _this.setState({
        allSelected: val
      });
      if (global) {
        for (const [key] of Object.entries(_this.selected)) {
          _this.selected[key].selected = val;
        }
        if (val) {
          _this.setSelectedCount(Object.keys(_this.selected).length);
        } else {
          _this.setSelectedCount(0);
        }
      }
    };
    this.selected = {};
    this.state = {
      allSelected: false,
      selectedCount: 0
    };
  }
  render() {
    const {
      children
    } = this.props;
    const {
      allSelected,
      selectedCount
    } = this.state;
    return /*#__PURE__*/React__default["default"].createElement(BulkActionsContext.Provider, {
      value: {
        bulkActionContext: this.selected,
        addToSelected: this.addToSelected,
        setAllSelected: this.setAllSelected,
        allSelected: allSelected,
        selectedCount: selectedCount
      }
    }, children);
  }
}
SearchResultsBulkActionsManager.contextType = BulkActionsContext;

class SearchResultsRowCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.isChecked = (bulkActionContext, allSelected) => {
      const {
        rowId
      } = this.props;
      if (_hasIn__default["default"](bulkActionContext, `${rowId}`) || allSelected) {
        return bulkActionContext[rowId].selected;
      }
      return false;
    };
    this.subscribeToContext = () => {
      const {
        rowId,
        data
      } = this.props;
      const {
        allSelected,
        bulkActionContext
      } = this.context;
      if (!_hasIn__default["default"](bulkActionContext, `${rowId}`)) {
        bulkActionContext[rowId] = {
          selected: allSelected,
          data: data
        };
      }
    };
    this.handleOnChange = () => {
      const {
        addToSelected
      } = this.context;
      const {
        rowId,
        data
      } = this.props;
      const {
        isChecked
      } = this.state;
      this.setState({
        isChecked: !isChecked
      });
      addToSelected(rowId, data);
    };
    this.state = {
      isChecked: false
    };
  }
  componentDidMount() {
    this.subscribeToContext();
    const {
      bulkActionContext,
      allSelected
    } = this.context;
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      isChecked: this.isChecked(bulkActionContext, allSelected)
    });
  }
  render() {
    const {
      bulkActionContext,
      allSelected
    } = this.context;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Checkbox, {
      className: "mt-auto mb-auto ",
      checked: this.isChecked(bulkActionContext, allSelected) || allSelected,
      onChange: this.handleOnChange
    });
  }
}
SearchResultsRowCheckbox.contextType = BulkActionsContext;

class GridResponsiveSidebarColumn extends React__default["default"].Component {
  render() {
    const closeSidebarBtnRef = /*#__PURE__*/React__default["default"].createRef();
    const {
      mobile,
      tablet,
      computer,
      widescreen,
      largeScreen,
      width,
      open,
      onHideClick,
      children,
      ariaLabel
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      as: "aside",
      "aria-label": ariaLabel,
      mobile: mobile,
      tablet: tablet,
      width: width,
      only: "mobile tablet"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Sidebar, {
      as: semanticUiReact.Segment,
      animation: "overlay",
      visible: open,
      width: "wide",
      onHide: onHideClick,
      onShow: () => closeSidebarBtnRef.current.focus()
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      basic: true,
      icon: "close",
      size: "small",
      floated: "right",
      onClick: onHideClick,
      "aria-label": "Close filter",
      ref: closeSidebarBtnRef,
      className: "mb-20"
    }), children)), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      as: "aside",
      "aria-label": ariaLabel,
      width: width,
      only: "computer",
      computer: computer,
      largeScreen: largeScreen,
      widescreen: widescreen
    }, children));
  }
}
GridResponsiveSidebarColumn.defaultProps = {
  width: undefined,
  mobile: undefined,
  tablet: undefined,
  computer: undefined,
  widescreen: undefined,
  largeScreen: undefined,
  ariaLabel: undefined
};

// This file is part of React-Invenio-Forms
const FieldErrorList = _ref => {
  let {
    fieldErrors
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.List, null, fieldErrors.map(error => {
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.Item, {
      key: error
    }, error.field && error.field !== "_schema" && /*#__PURE__*/React__default["default"].createElement("strong", null, error.field, ": "), error.message ? error.message : error.messages && error.messages.length === 1 ? error.messages[0] : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.List, null, error.messages.map(message => /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.Item, {
      key: message
    }, message))));
  }));
};
/**
 * General component for error messages.
 * Handles:
 *   - simple error messages: provide custom header, and content - response message of received error;
 *   - complex error messages: provide list or received errors.
 * Icon and other ui props are supported.
 */
class ErrorMessage extends React.Component {
  render() {
    const {
      header,
      errors,
      content,
      icon,
      ...uiProps
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message, Object.assign({
      icon: Boolean(icon)
    }, uiProps), icon && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: icon
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.Content, {
      role: "alert"
    }, header && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message.Header, null, header), content, !_isEmpty__default["default"](errors) && /*#__PURE__*/React__default["default"].createElement(FieldErrorList, {
      fieldErrors: errors
    })));
  }
}
ErrorMessage.defaultProps = {
  errors: undefined,
  header: undefined,
  uiProps: undefined,
  icon: undefined,
  content: undefined
};

// This file is part of React-Invenio-Forms
function humanReadableBytes(bytes) {
  let decimalDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (_isNumber__default["default"](bytes)) {
    const base = decimalDisplay ? 1000 : 1024;
    const kiloBytes = base;
    const megaBytes = base * kiloBytes;
    const gigaBytes = base * megaBytes;
    if (bytes < kiloBytes) {
      return `${bytes} bytes`;
    } else if (bytes < megaBytes) {
      return `${(bytes / kiloBytes).toFixed(2)} ${decimalDisplay ? "KB" : "KiB"}`;
    } else if (bytes < gigaBytes) {
      return `${(bytes / megaBytes).toFixed(2)} ${decimalDisplay ? "MB" : "MiB"}`;
    } else {
      return `${(bytes / gigaBytes).toFixed(2)} ${decimalDisplay ? "GB" : "GiB"}`;
    }
  }
  return "";
}

// This file is part of React-Invenio-Forms
function dropdownOptionsGenerator(dropdownOptions) {
  return dropdownOptions.map(options => {
    return {
      key: options.key,
      text: options.text,
      value: options.key,
      content: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", null, options.text), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("small", {
        className: "text-muted"
      }, options.description)))
    };
  });
}

// This file is part of React-Invenio-Forms
// Copyright (C) 2025 CERN.
//
// React-Invenio-Forms is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

function flattenAndCategorizeErrors(obj) {
  let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  const flattenedErrors = {};
  const severityChecks = {};

  // If obj is a string, treat it as a single error message i.e. old error format
  if (typeof obj === "string") {
    flattenedErrors[prefix || "error"] = obj;
    return {
      flattenedErrors,
      severityChecks
    };
  }

  // Handle direct severity-based error objects i.e. new error format
  if (obj.message && obj.severity) {
    severityChecks[prefix || "error"] = obj;
    return {
      flattenedErrors,
      severityChecks
    };
  }
  for (const [key, value] of Object.entries(obj)) {
    const newKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "object") {
      if (value.message && value.severity) {
        // Handle severity-based error format
        severityChecks[newKey] = value;
      } else if (Array.isArray(value)) {
        // Handle arrays
        value.forEach((item, index) => {
          const arrayKey = `${newKey}[${index}]`;
          if (item && typeof item === "object") {
            const {
              flattenedErrors: nestedErrors,
              severityChecks: nestedChecks
            } = flattenAndCategorizeErrors(item, arrayKey);
            Object.assign(flattenedErrors, nestedErrors);
            Object.assign(severityChecks, nestedChecks);
          } else {
            flattenedErrors[arrayKey] = item;
          }
        });
      } else {
        // Handle nested objects
        const {
          flattenedErrors: nestedErrors,
          severityChecks: nestedChecks
        } = flattenAndCategorizeErrors(value, newKey);
        Object.assign(flattenedErrors, nestedErrors);
        Object.assign(severityChecks, nestedChecks);
      }
    } else {
      // Handle primitive values
      flattenedErrors[newKey] = value;
    }
  }
  return {
    flattenedErrors,
    severityChecks
  };
}

// This file is part of React-Invenio-Forms
class AccordionField extends React.Component {
  constructor() {
    super(...arguments);
    // Generates a summary of errors categorized by severity.
    this.getErrorSummary = (errors, includePaths, severityChecks) => {
      const count = {};

      // Count generic errors
      for (const path in errors.flattenedErrors) {
        if (includePaths.some(includePath => path.startsWith(includePath))) {
          count["error"] = (count["error"] || 0) + 1;
        }
      }

      // Count severity-based errors
      for (const key in errors.severityChecks) {
        var _errors$severityCheck;
        const severity = (_errors$severityCheck = errors.severityChecks[key]) === null || _errors$severityCheck === void 0 ? void 0 : _errors$severityCheck.severity;
        const path = key;
        if (severity && includePaths.some(includePath => path.startsWith(includePath))) {
          count[severity] = (count[severity] || 0) + 1;
        }
      }

      // Format output to display labels
      // e.g., { error: "1 Error", warning: "2 Warnings" }
      const formattedCount = {};
      for (const [severity, num] of Object.entries(count)) {
        var _severityChecks$sever;
        const label = (severityChecks === null || severityChecks === void 0 ? void 0 : (_severityChecks$sever = severityChecks[severity]) === null || _severityChecks$sever === void 0 ? void 0 : _severityChecks$sever.label) || severity.charAt(0).toUpperCase() + severity.slice(1);
        formattedCount[severity] = `${num} ${label}${num === 1 ? "" : "s"}`;
      }
      return formattedCount;
    };
    this.renderAccordion = props => {
      const {
        form: {
          errors,
          initialErrors
        }
      } = props;
      const {
        includesPaths,
        label,
        children,
        active,
        severityChecks
      } = this.props;
      const uiProps = _omit__default["default"](this.props, ["optimized", "includesPaths"]);

      // Merge initial and current errors for accurate validation
      const persistentErrors = {
        ...initialErrors,
        ...errors
      };
      const categorizedErrors = flattenAndCategorizeErrors(persistentErrors);

      // Determine if the accordion should show an "error" state
      const errorClass = this.hasError(categorizedErrors, includesPaths) ? "error" : "";

      // Generate summary of errors for display
      const errorSummary = this.getErrorSummary(categorizedErrors, includesPaths, severityChecks);
      const [activeIndex, setActiveIndex] = React.useState(active ? 0 : -1);
      const handleTitleClick = (e, _ref) => {
        let {
          index
        } = _ref;
        setActiveIndex(activeIndex === index ? -1 : index);
      };
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Accordion, Object.assign({
        inverted: true,
        className: `invenio-accordion-field ${errorClass} secondary`
      }, uiProps), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Accordion.Title, {
        active: activeIndex === 0,
        index: 0,
        onClick: handleTitleClick,
        onKeyDown: e => {
          if (e.key === "Enter" || e.key === " ") {
            handleTitleClick(e, {
              index: 0
            });
          }
        },
        tabIndex: 0
      }, label, Object.entries(errorSummary).map(_ref2 => {
        let [severity, text] = _ref2;
        return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
          key: severity,
          size: "tiny",
          circular: true,
          className: `accordion-label ${severity}`
        }, text);
      }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: activeIndex === 0 ? "angle down" : "angle right"
      })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Accordion.Content, {
        active: activeIndex === 0
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Container, null, children)));
    };
  }
  // Checks if there are any errors that match the given paths.

  hasError(errors, includesPaths) {
    if (Object.keys(errors.flattenedErrors).some(errorPath => includesPaths.some(path => errorPath.startsWith(path)))) {
      return true;
    }
    return Object.keys(errors.severityChecks).some(errorPath => includesPaths.some(path => errorPath.startsWith(path)) && errors.severityChecks[errorPath].severity === "error");
  }
  render() {
    const {
      optimized
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, {
      name: "",
      component: this.renderAccordion
    });
  }
}
AccordionField.defaultProps = {
  active: true,
  includesPaths: [],
  label: "",
  optimized: false,
  children: null,
  ui: null,
  severityChecks: null
};

// This file is part of React-Invenio-Forms
class FieldLabel extends React.Component {
  render() {
    const {
      htmlFor,
      icon,
      label,
      className
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: htmlFor,
      className: className
    }, icon ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: icon
    }) : null, label);
  }
}
FieldLabel.defaultProps = {
  className: "field-label-class invenio-field-label",
  icon: "",
  htmlFor: undefined,
  label: undefined
};

// This file is part of React-Invenio-Forms
class ArrayField extends React.Component {
  constructor(_props) {
    super(_props);
    this.hasGroupErrors = errors => {
      const {
        fieldPath
      } = this.props;
      for (const field in errors) {
        if (field.startsWith(fieldPath)) {
          return true;
        }
      }
      return false;
    };
    /**
     * Returns the array of values to display, it checks for required options and adds empty rows with the required values prefilled
     * @param {Array} values The array of values
     * @param {String} fieldPath The path of the field
     * @returns An array of values to display
     */
    this.getValues = (values, fieldPath) => {
      const {
        requiredOptions,
        defaultNewValue,
        showEmptyValue
      } = this.props;
      const {
        hasBeenShown
      } = this.state;
      const existingValues = formik.getIn(values, fieldPath, []);
      if (!hasBeenShown && _isEmpty__default["default"](requiredOptions) && _isEmpty__default["default"](existingValues) && showEmptyValue) {
        existingValues.push({
          __key: existingValues.length,
          ...defaultNewValue
        });
        this.setState({
          hasBeenShown: true
        });
      }
      for (const requiredOption of requiredOptions) {
        const valuesMatchingRequiredOption = _filter__default["default"](existingValues, _matches__default["default"](requiredOption));
        if (valuesMatchingRequiredOption.length === 0) {
          existingValues.push({
            __key: existingValues.length,
            ...requiredOption
          });
        }
      }
      return existingValues;
    };
    this.renderFormField = props => {
      const {
        form: {
          values,
          errors
        },
        ...arrayHelpers
      } = props;
      const {
        addButtonLabel,
        addButtonClassName,
        children,
        defaultNewValue,
        fieldPath,
        label,
        labelIcon,
        helpText,
        requiredOptions,
        showEmptyValue,
        ...uiProps
      } = this.props;
      const hasError = this.hasGroupErrors(errors) ? {
        error: {}
      } : {};
      const {
        nextKey
      } = this.state;
      const valuesToDisplay = this.getValues(values, fieldPath);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, Object.assign({}, uiProps, hasError), /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: labelIcon,
        label: label
      }), valuesToDisplay.map((value, index, array) => {
        const arrayPath = fieldPath;
        const indexPath = index;
        const key = value.__key || index;
        return /*#__PURE__*/React__default["default"].createElement("div", {
          key: key
        }, children({
          array,
          arrayHelpers,
          arrayPath,
          indexPath,
          key,
          value,
          ...props
        }));
      }), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
        className: "helptext"
      }, helpText), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Button, {
        type: "button",
        icon: true,
        className: addButtonClassName,
        labelPosition: "left",
        onClick: () => {
          arrayHelpers.push({
            ...defaultNewValue,
            __key: nextKey
          });
          this.setState(state => ({
            nextKey: state.nextKey - 1
          }));
        }
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "add"
      }), addButtonLabel)));
    };
    this.state = {
      // Chosen because it will never cross with 0-indexed pre-existing keys.
      nextKey: -1,
      hasBeenShown: false
    };
  }
  render() {
    const {
      fieldPath
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(formik.FieldArray, {
      className: "invenio-array-field",
      name: fieldPath,
      id: fieldPath,
      component: this.renderFormField
    });
  }
}
ArrayField.defaultProps = {
  addButtonLabel: "Add new row",
  addButtonClassName: "align-self-end mt-15",
  helpText: "",
  label: "",
  labelIcon: "",
  requiredOptions: [],
  showEmptyValue: false
};

// This file is part of React-Invenio-Forms
class BaseForm extends React.Component {
  render() {
    const {
      formik: formik$1,
      onSubmit,
      children
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(formik.Formik, Object.assign({
      onSubmit: onSubmit
    }, formik$1), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form, null, children));
  }
}
BaseForm.defaultProps = {
  formik: undefined
};

// This file is part of React-Invenio-Forms
class BooleanField extends React.Component {
  constructor() {
    super(...arguments);
    this.renderFormField = props => {
      const {
        fieldPath,
        label,
        ...uiProps
      } = this.props;
      const {
        form: {
          values,
          handleBlur,
          errors,
          initialErrors,
          initialValues,
          setFieldValue
        }
      } = props;
      const value = formik.getIn(values, fieldPath, false);
      const initialValue = formik.getIn(initialValues, fieldPath, false);
      // We check if initialValue changed to display the initialError,
      // otherwise it would be displayed despite updating the field
      const fieldErrors = errors || initialValue === value && initialErrors;
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
        inline: true
      }, /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: fieldPath
      }, label), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Checkbox, Object.assign({
        id: fieldPath,
        name: fieldPath,
        onChange: () => setFieldValue(fieldPath, !value),
        onBlur: handleBlur,
        checked: value,
        error: this.renderError(fieldErrors, fieldPath)
      }, uiProps)));
    };
  }
  renderError(errors, name) {
    let direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "left";
    const error = errors[name];
    return error ? {
      content: error,
      pointing: direction
    } : null;
  }
  render() {
    const {
      optimized,
      fieldPath
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, {
      className: "invenio-boolean-field",
      name: fieldPath,
      component: this.renderFormField
    });
  }
}
BooleanField.defaultProps = {
  label: "",
  optimized: false
};

// This file is part of React-Invenio-Forms
class ErrorLabel extends React.Component {
  constructor() {
    super(...arguments);
    this.renderFormField = _ref => {
      let {
        form: {
          errors,
          initialErrors
        }
      } = _ref;
      const {
        fieldPath,
        ...uiProps
      } = this.props;
      const error = _get__default["default"](errors, fieldPath, "") || _get__default["default"](initialErrors, fieldPath, "");
      return error ? /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, Object.assign({
        pointing: true,
        prompt: true,
        content: error
      }, uiProps)) : null;
    };
  }
  render() {
    const {
      fieldPath
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      className: "invenio-error-label-field",
      name: fieldPath
    }, this.renderFormField);
  }
}

class FeedbackLabel extends React.Component {
  render() {
    const {
      errorMessage,
      pointing
    } = this.props;
    const {
      flattenedErrors = {},
      severityChecks = {}
    } = flattenAndCategorizeErrors(errorMessage);

    // Get the first error and severity data, defaulting to empty values if not present
    const errorText = Object.values(flattenedErrors)[0] || "";
    const severityData = Object.values(severityChecks)[0] || {};

    // Destructure severityData, ensuring default values for missing keys
    const severityLevel = (severityData === null || severityData === void 0 ? void 0 : severityData.severity) || "";
    const severityMessage = (severityData === null || severityData === void 0 ? void 0 : severityData.message) || "";
    const severityDescription = (severityData === null || severityData === void 0 ? void 0 : severityData.description) || "";
    const severityInfo = {
      severityLevel,
      severityMessage,
      severityDescription
    };
    const hasError = errorText !== "" || severityInfo.severityLevel === "error";
    const className = hasError ? "prompt" : severityInfo.severityLevel;
    const icon = hasError ? "times circle" : "info circle";

    // Return null if neither errorText nor severityMessage exists
    if (!errorText && !severityInfo.severityMessage) {
      return null;
    }
    const hasSeverity = severityInfo.severityMessage && severityInfo.severityDescription;
    return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
      pointing: pointing,
      className: className
    }, hasSeverity && /*#__PURE__*/React__default["default"].createElement(InvenioPopup, {
      trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: icon
      })
      // Rule descriptions can contain HTML to link to a page with more details about the rule.
      // This field is sanitized in the backend with SanitizedHTML.
      ,
      content: /*#__PURE__*/React__default["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: severityInfo.severityDescription
        }
      }),
      position: "top center",
      hoverable: true
    }), errorText || severityInfo.severityMessage);
  }
}
FeedbackLabel.defaultProps = {
  errorMessage: undefined,
  pointing: "left"
};

// This file is part of React-Invenio-Forms
class GroupField extends React__default["default"].Component {
  constructor() {
    super(...arguments);
    this.hasGroupErrors = errors => {
      const {
        fieldPath
      } = this.props;
      for (const field in errors) {
        if (field.startsWith(fieldPath)) {
          return true;
        }
      }
      return false;
    };
    this.renderBasicField = (action, classNames, children) => {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: classNames.join(" ")
      }, action && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "group-action"
      }, action), children);
    };
    this.renderFormField = props => {
      const {
        action,
        basic,
        border,
        children,
        fieldPath,
        ...uiProps
      } = props;
      const errors = formik.getIn(props, "form.errors");
      const classNames = ["form-group"];
      if (border) {
        classNames.push("border");
      }
      if (fieldPath && this.hasGroupErrors(errors)) {
        classNames.push("error");
      }
      if (basic) {
        return this.renderBasicField(action, classNames, children);
      }
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, Object.assign({
        className: classNames.join(" ")
      }, uiProps), action && /*#__PURE__*/React__default["default"].createElement("div", {
        className: "group-action"
      }, action), children);
    };
  }
  render() {
    const {
      optimized,
      fieldPath,
      ...uiProps
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, Object.assign({
      name: fieldPath,
      component: this.renderFormField,
      fieldPath: fieldPath,
      className: "invenio-group-field"
    }, uiProps));
  }
}
GroupField.defaultProps = {
  border: false,
  fieldPath: "",
  optimized: false,
  action: undefined,
  basic: false,
  children: undefined
};

// This file is part of React-Invenio-Forms
class SelectField extends React.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    this.renderError = function (errors, name, value) {
      let direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "above";
      const {
        options
      } = _this.props;
      let error = null;
      if (!Array.isArray(value)) {
        if (!_isEmpty__default["default"](options) && !options.find(o => o.value === value) && !_isEmpty__default["default"](value)) {
          error = `The current value "${value}" is invalid, please select another value.`;
        }
      }
      if (!error) {
        error = errors[name];
      }
      return error ? {
        content: error,
        pointing: direction
      } : null;
    };
    this.renderFormField = formikProps => {
      const {
        form: {
          values,
          setFieldValue,
          handleBlur,
          errors,
          initialErrors,
          initialValues
        },
        ...cmpProps
      } = formikProps;
      const {
        defaultValue,
        error,
        fieldPath,
        label,
        options,
        onChange,
        onAddItem,
        multiple,
        ...uiProps
      } = cmpProps;
      const _defaultValue = multiple ? [] : "";
      const value = formik.getIn(values, fieldPath, defaultValue || _defaultValue);
      const initialValue = formik.getIn(initialValues, fieldPath, _defaultValue);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Dropdown, Object.assign({
        fluid: true,
        className: "invenio-select-field",
        selection: true,
        error: error || formik.getIn(errors, fieldPath, null) ||
        // We check if initialValue changed to display the initialError,
        // otherwise it would be displayed despite updating the fieldu
        initialValue === value && formik.getIn(initialErrors, fieldPath, null),
        label: {
          children: label
        },
        name: fieldPath,
        onBlur: handleBlur,
        onChange: (event, data) => {
          if (onChange) {
            onChange({
              event,
              data,
              formikProps
            });
            event.target.value = "";
          } else {
            setFieldValue(fieldPath, data.value);
          }
        },
        onAddItem: (event, data) => {
          if (onAddItem) {
            onAddItem({
              event,
              data,
              formikProps
            });
          }
        },
        options: options,
        value: value,
        multiple: multiple,
        selectOnBlur: false
      }, uiProps));
    };
  }
  render() {
    const {
      optimized,
      fieldPath,
      ...uiProps
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, Object.assign({
      name: fieldPath,
      component: this.renderFormField,
      fieldPath: fieldPath
    }, uiProps));
  }
}
SelectField.defaultProps = {
  defaultValue: "",
  optimized: false,
  error: undefined,
  label: "",
  onChange: undefined,
  onAddItem: undefined,
  multiple: false
};

// This file is part of React-Invenio-Forms
const baseAxiosConfiguration = {
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
  headers: {
    "Accept": "application/vnd.inveniordm.v1+json",
    "Content-Type": "application/json"
  }
};
const http = axios__default["default"].create(baseAxiosConfiguration);

// This file is part of React-Invenio-Forms
// Copyright (C) 2022 CERN.
//
// React-Invenio-Forms is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Wrap a promise to be cancellable and avoid potential memory leaks
 * https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
 * @param promise the promise to wrap
 * @returns {Object} an object containing the promise to resolve and a `cancel` fn to reject the promise
 */
const withCancel = promise => {
  let isCancelled = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(val => isCancelled ? reject("UNMOUNTED") : resolve(val), error => isCancelled ? reject("UNMOUNTED") : reject(error));
  });
  return {
    promise: wrappedPromise,
    cancel() {
      isCancelled = true;
    }
  };
};

// This file is part of React-Invenio-Deposit
const DEFAULT_SUGGESTION_SIZE = 20;
const serializeSuggestions = suggestions => suggestions.map(item => ({
  text: item.title,
  value: item.id,
  key: item.id
}));
class RemoteSelectField extends React.Component {
  constructor(props) {
    super(props);
    this.onSelectValue = (event, _ref, callbackFunc) => {
      let {
        options,
        value,
        ...otherData
      } = _ref;
      const {
        multiple
      } = this.props;
      const newSelectedSuggestions = options.filter(item => {
        if (multiple) {
          // "value" is an array so check if it includes the option's value
          return value.includes(item.value);
        } else {
          // "value" is a string so we just compare directly
          return item.value === value;
        }
      });
      this.setState({
        selectedSuggestions: newSelectedSuggestions,
        searchQuery: null,
        error: false,
        open: !!multiple
      }, () => callbackFunc(newSelectedSuggestions));
    };
    this.handleAddition = (e, _ref2, callbackFunc) => {
      let {
        value
      } = _ref2;
      const {
        serializeAddedValue
      } = this.props;
      const {
        selectedSuggestions
      } = this.state;
      const selectedSuggestion = serializeAddedValue ? serializeAddedValue(value) : {
        text: value,
        value,
        key: value,
        name: value
      };
      const newSelectedSuggestions = [...selectedSuggestions, selectedSuggestion];
      this.setState(prevState => ({
        selectedSuggestions: newSelectedSuggestions,
        suggestions: _uniqBy__default["default"]([...prevState.suggestions, ...newSelectedSuggestions], "value")
      }), () => callbackFunc(newSelectedSuggestions));
    };
    this.onSearchChange = _debounce__default["default"](async (e, _ref3) => {
      let {
        searchQuery
      } = _ref3;
      this.cancellableAction && this.cancellableAction.cancel();
      await this.executeSearch(searchQuery);
      // eslint-disable-next-line react/destructuring-assignment
    }, this.props.debounceTime);
    // can't destructure as prop variable is used outside the inner function
    this.executeSearch = async searchQuery => {
      const {
        preSearchChange,
        serializeSuggestions
      } = this.props;
      const query = preSearchChange(searchQuery);
      // If there is no query change, then display prevState suggestions
      const {
        searchQuery: prevSearchQuery
      } = this.state;
      if (prevSearchQuery === searchQuery) {
        return;
      }
      this.setState({
        isFetching: true,
        searchQuery: query
      });
      try {
        const suggestions = await this.fetchSuggestions(query);
        const serializedSuggestions = serializeSuggestions(suggestions);
        this.setState(prevState => ({
          suggestions: _uniqBy__default["default"]([...prevState.selectedSuggestions, ...serializedSuggestions], "key"),
          isFetching: false,
          error: false,
          open: true
        }));
      } catch (e) {
        console.error(e);
        this.setState({
          error: true,
          isFetching: false
        });
      }
    };
    this.fetchSuggestions = async searchQuery => {
      const {
        suggestionAPIUrl,
        suggestionAPIQueryParams,
        suggestionAPIHeaders,
        searchQueryParamName
      } = this.props;
      this.cancellableAction = withCancel(axios__default["default"].get(suggestionAPIUrl, {
        params: {
          [searchQueryParamName]: searchQuery,
          size: DEFAULT_SUGGESTION_SIZE,
          ...suggestionAPIQueryParams
        },
        headers: suggestionAPIHeaders,
        // There is a bug in axios that prevents brackets from being encoded,
        // remove the paramsSerializer when fixed.
        // https://github.com/axios/axios/issues/3316
        paramsSerializer: params => queryString__default["default"].stringify(params, {
          arrayFormat: "repeat"
        })
      }));
      try {
        var _response$data, _response$data$hits;
        const response = await this.cancellableAction.promise;
        return response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$hits = _response$data.hits) === null || _response$data$hits === void 0 ? void 0 : _response$data$hits.hits;
      } catch (e) {
        console.error(e);
      }
    };
    this.getNoResultsMessage = () => {
      const {
        loadingMessage,
        suggestionsErrorMessage,
        noQueryMessage,
        noResultsMessage
      } = this.props;
      const {
        isFetching,
        error,
        searchQuery
      } = this.state;
      if (isFetching) {
        return loadingMessage;
      }
      if (error) {
        return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Message, {
          negative: true,
          size: "mini",
          content: suggestionsErrorMessage
        });
      }
      if (!searchQuery) {
        return noQueryMessage;
      }
      return noResultsMessage;
    };
    this.onClose = () => {
      this.setState({
        open: false
      });
    };
    this.onBlur = () => {
      const {
        searchOnFocus
      } = this.props;
      this.setState(prevState => ({
        open: false,
        error: false,
        searchQuery: searchOnFocus ? prevState.searchQuery : null,
        suggestions: searchOnFocus ? prevState.suggestions : prevState.selectedSuggestions
      }));
    };
    this.onFocus = async () => {
      this.setState({
        open: true
      });
      const {
        searchOnFocus
      } = this.props;
      if (searchOnFocus) {
        const {
          searchQuery
        } = this.state;
        await this.executeSearch(searchQuery || "");
      }
    };
    this.getProps = () => {
      const {
        fieldPath,
        suggestionAPIUrl,
        suggestionAPIQueryParams,
        serializeSuggestions,
        serializeAddedValue,
        suggestionAPIHeaders,
        debounceTime,
        searchQueryParamName,
        noResultsMessage,
        loadingMessage,
        suggestionsErrorMessage,
        noQueryMessage,
        initialSuggestions,
        preSearchChange,
        onValueChange,
        search,
        isFocused,
        ...uiProps
      } = this.props;
      const compProps = {
        fieldPath,
        suggestionAPIUrl,
        suggestionAPIQueryParams,
        suggestionAPIHeaders,
        serializeSuggestions,
        serializeAddedValue,
        debounceTime,
        searchQueryParamName,
        noResultsMessage,
        loadingMessage,
        suggestionsErrorMessage,
        noQueryMessage,
        initialSuggestions,
        preSearchChange,
        onValueChange,
        search,
        isFocused
      };
      return {
        compProps,
        uiProps
      };
    };
    const _initialSuggestions = props.initialSuggestions ? props.serializeSuggestions(props.initialSuggestions) : [];
    this.state = {
      isFetching: false,
      suggestions: _initialSuggestions,
      selectedSuggestions: _initialSuggestions,
      error: false,
      searchQuery: null,
      open: false
    };
  }
  componentWillUnmount() {
    this.cancellableAction && this.cancellableAction.cancel();
  }
  render() {
    const {
      compProps,
      uiProps
    } = this.getProps();
    const {
      error,
      suggestions,
      open,
      isFetching
    } = this.state;
    return /*#__PURE__*/React__default["default"].createElement(SelectField, Object.assign({}, uiProps, {
      allowAdditions: error ? false : uiProps.allowAdditions,
      fieldPath: compProps.fieldPath,
      options: suggestions,
      noResultsMessage: this.getNoResultsMessage(),
      search: compProps.search,
      searchInput: {
        id: compProps.fieldPath,
        autoFocus: compProps.isFocused
      },
      lazyLoad: true,
      open: open,
      onClose: this.onClose,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onSearchChange: this.onSearchChange,
      onAddItem: _ref4 => {
        let {
          event,
          data,
          formikProps
        } = _ref4;
        this.handleAddition(event, data, selectedSuggestions => {
          if (compProps.onValueChange) {
            compProps.onValueChange({
              event,
              data,
              formikProps
            }, selectedSuggestions);
          }
        });
      },
      onChange: _ref5 => {
        let {
          event,
          data,
          formikProps
        } = _ref5;
        this.onSelectValue(event, data, selectedSuggestions => {
          if (compProps.onValueChange) {
            compProps.onValueChange({
              event,
              data,
              formikProps
            }, selectedSuggestions);
          } else {
            formikProps.form.setFieldValue(compProps.fieldPath, data.value);
          }
        });
      },
      loading: isFetching,
      className: "invenio-remote-select-field"
    }));
  }
}
RemoteSelectField.defaultProps = {
  debounceTime: 500,
  suggestionAPIQueryParams: {},
  suggestionAPIHeaders: {},
  serializeSuggestions: serializeSuggestions,
  searchQueryParamName: "suggest",
  suggestionsErrorMessage: "Something went wrong...",
  noQueryMessage: "Search...",
  noResultsMessage: "No results found.",
  loadingMessage: "Loading...",
  preSearchChange: x => x,
  search: true,
  multiple: false,
  serializeAddedValue: undefined,
  initialSuggestions: [],
  onValueChange: undefined,
  isFocused: false,
  searchOnFocus: false
};

// This file is part of React-Invenio-Forms
class TextField extends React.Component {
  render() {
    const {
      fieldPath,
      error,
      helpText,
      disabled,
      label,
      optimized,
      required,
      ...uiProps
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FormikField, {
      className: "invenio-text-input-field",
      id: fieldPath,
      name: fieldPath
    }, _ref => {
      let {
        field,
        meta
      } = _ref;
      const computedError = error || meta.error ||
      // We check if initialValue changed to display the initialError,
      // otherwise it would be displayed despite updating the field
      !meta.touched && meta.initialError;
      let formInputError = null;
      if (typeof computedError === "string") {
        formInputError = computedError;
      } else if (typeof computedError === "object" && computedError.message && computedError.severity) {
        formInputError = /*#__PURE__*/React__default["default"].createElement(FeedbackLabel, {
          errorMessage: computedError,
          pointing: "above"
        });
      }
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Input, Object.assign({}, field, {
        error: formInputError,
        disabled: disabled,
        fluid: true,
        label: label,
        id: fieldPath,
        required: required
      }, uiProps));
    }), helpText && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, helpText));
  }
}
TextField.defaultProps = {
  error: undefined,
  helpText: "",
  disabled: false,
  optimized: false,
  required: false
};

// This file is part of React-Invenio-Forms
class TextAreaField extends React.Component {
  constructor() {
    super(...arguments);
    this.renderFormField = _ref => {
      let {
        form,
        ...cmpProps
      } = _ref;
      const {
        fieldPath,
        ...uiProps
      } = cmpProps;
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
        className: "invenio-text-area-field"
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.TextArea, Object.assign({
        id: fieldPath,
        name: fieldPath,
        onChange: form.handleChange,
        onBlur: form.handleBlur,
        value: formik.getIn(form.values, fieldPath, "")
      }, uiProps)), /*#__PURE__*/React__default["default"].createElement(ErrorLabel, {
        fieldPath: fieldPath
      }));
    };
  }
  render() {
    const {
      optimized,
      fieldPath,
      ...props
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, Object.assign({
      id: fieldPath,
      name: fieldPath,
      component: this.renderFormField,
      fieldPath: fieldPath
    }, props));
  }
}
TextAreaField.defaultProps = {
  optimized: false
};

// This file is part of React-Invenio-Forms
class RadioField extends React.Component {
  constructor() {
    super(...arguments);
    /** Radio Formik wrapper Component */
    this.renderFormField = formikProps => {
      /** Radio Formik + Semantic-UI Field Component
       *
       * NOTE: renderFormField is run multiple times
       * TODO: might gain performance by extracting it out as own component and
       *       using class methods
       *
       * field: current Formik field (RadioField instance)
       * form: current Formik form (holds formik state that drives the UI)
       */

      const {
        checked,
        fieldPath,
        label,
        labelIcon,
        onChange,
        value,
        ...ui
      } = this.props;
      const handleChange = (event, data) => {
        if (onChange) {
          onChange({
            event,
            data,
            formikProps
          });
        } else {
          formikProps.form.setFieldValue(fieldPath, value);
        }
      };
      const uiProps = _omit__default["default"](ui, ["optimized"]);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Radio, Object.assign({
        name: fieldPath,
        label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
          htmlFor: fieldPath,
          icon: labelIcon,
          label: label
        }),
        value: formik.getIn(formikProps.form.values, fieldPath, ""),
        checked: checked,
        onChange: handleChange,
        className: "invenio-radio-field"
      }, uiProps));
    };
  }
  render() {
    const {
      optimized,
      fieldPath
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, {
      name: fieldPath,
      component: this.renderFormField
    });
  }
}
RadioField.defaultProps = {
  checked: false,
  label: "",
  optimized: false,
  labelIcon: "",
  onChange: undefined,
  value: ""
};

// This file is part of React-Invenio-Forms
class RichEditor extends React.Component {
  render() {
    const {
      id,
      initialValue,
      disabled,
      minHeight,
      onBlur,
      onChange,
      onFocus,
      editorConfig,
      inputValue,
      onEditorChange
    } = this.props;
    const config = {
      branding: false,
      menubar: false,
      statusbar: false,
      min_height: minHeight,
      content_style: "body { font-size: 14px; }",
      plugins: ["codesample", "link", "lists", "table", "autoresize", "wordcount"],
      contextmenu: false,
      toolbar: "blocks | bold italic link codesample blockquote table | bullist numlist | outdent indent | wordcount | undo redo",
      autoresize_bottom_margin: 20,
      block_formats: "Paragraph=p; Header 1=h1; Header 2=h2; Header 3=h3",
      table_advtab: false,
      convert_urls: false,
      ...editorConfig
    };
    return /*#__PURE__*/React__default["default"].createElement(tinymceReact.Editor, {
      initialValue: initialValue,
      value: inputValue,
      init: config,
      id: id,
      disabled: disabled,
      onBlur: onBlur,
      onFocus: onFocus,
      onChange: onChange,
      onEditorChange: onEditorChange
    });
  }
}
RichEditor.defaultProps = {
  minHeight: 250,
  initialValue: "",
  inputValue: "",
  id: undefined,
  disabled: undefined,
  onChange: undefined,
  onEditorChange: undefined,
  onBlur: undefined,
  onFocus: undefined,
  editorConfig: undefined
};

// This file is part of React-Invenio-Deposit
class RichInputField extends React.Component {
  constructor() {
    super(...arguments);
    this.renderFormField = formikBag => {
      const {
        fieldPath,
        label,
        required,
        className,
        editor,
        editorConfig
      } = this.props;
      const value = formik.getIn(formikBag.form.values, fieldPath, "");
      const initialValue = formik.getIn(formikBag.form.initialValues, fieldPath, "");
      const error = formik.getIn(formikBag.form.errors, fieldPath, false) ||
      // We check if initialValue changed to display the initialError,
      // otherwise it would be displayed despite updating the field
      initialValue === value && formik.getIn(formikBag.form.initialErrors, fieldPath, false);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
        id: fieldPath,
        required: required,
        error: error,
        className: className
      }, /*#__PURE__*/React__default["default"].isValidElement(label) ? label : /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: fieldPath
      }, label), editor ? editor : /*#__PURE__*/React__default["default"].createElement(RichEditor, {
        initialValue: initialValue,
        inputValue: () => value // () =>  To avoid re-rendering
        ,
        optimized: true,
        editorConfig: editorConfig,
        onBlur: (event, editor) => {
          formikBag.form.setFieldValue(fieldPath, editor.getContent());
          formikBag.form.setFieldTouched(fieldPath, true);
        }
      }), /*#__PURE__*/React__default["default"].createElement(ErrorLabel, {
        fieldPath: fieldPath
      }));
    };
  }
  render() {
    const {
      optimized,
      fieldPath
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, {
      id: fieldPath,
      name: fieldPath,
      component: this.renderFormField
    });
  }
}
RichInputField.defaultProps = {
  className: "invenio-rich-input-field",
  optimized: false,
  required: false,
  label: "",
  editor: undefined,
  editorConfig: undefined
};

// This file is part of React-Invenio-Forms
class ToggleField extends React.Component {
  constructor() {
    super(...arguments);
    /** Radio toggle Formik wrapper Component */
    this.renderFormField = formikProps => {
      /** Radio toggle Formik + Semantic-UI Field Component
       *
       * NOTE: renderFormField is run multiple times
       * TODO: might gain performance by extracting it out as own component and
       *       using class methods
       *
       * formikProps: current Formik props (ToggleField instance)
       */

      const {
        onValue,
        offValue,
        onLabel,
        offLabel,
        fieldPath,
        onChange,
        ...uiProps
      } = this.props;
      const isChecked = formik.getIn(formikProps.form.values, fieldPath) === onValue;
      const handleChange = () => {
        if (isChecked) {
          formikProps.form.setFieldValue(fieldPath, offValue);
        } else {
          formikProps.form.setFieldValue(fieldPath, onValue);
        }
        if (onChange) {
          onChange({
            checked: !isChecked
          });
        }
      };
      return /*#__PURE__*/React__default["default"].createElement(RadioField, Object.assign({}, uiProps, {
        className: "invenio-toggle-field",
        toggle: true,
        fieldPath: fieldPath,
        checked: formik.getIn(formikProps.form.values, fieldPath) === onValue,
        label: formik.getIn(formikProps.form.values, fieldPath) === onValue ? onLabel : offLabel,
        onChange: handleChange
      }));
    };
  }
  render() {
    const {
      optimized,
      fieldPath
    } = this.props;
    const FormikField = optimized ? formik.FastField : formik.Field;
    return /*#__PURE__*/React__default["default"].createElement(FormikField, {
      name: fieldPath,
      component: this.renderFormField
    });
  }
}
ToggleField.defaultProps = {
  onChange: undefined,
  optimized: true
};

class RemoveField extends React.Component {
  render() {
    const {
      removeFieldCallback,
      fieldPath,
      field,
      label
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
      htmlFor: fieldPath,
      label: label,
      className: "mr-10"
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Popup, {
      content: "Remove empty fields from the form",
      trigger: /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
        icon: true,
        size: "mini",
        onClick: () => removeFieldCallback(field)
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "trash alternate outline"
      }))
    }));
  }
}

class ListAndFilterCustomFields extends React.Component {
  constructor(props) {
    super(props);
    this.resetFilter = () => {
      const {
        fieldsList
      } = this.props;
      this.setState({
        filteredFieldsList: fieldsList
      });
    };
    this.filter = () => {
      const {
        fieldsList
      } = this.props;
      const {
        searchPhrase,
        filter
      } = this.state;
      if (!searchPhrase && !filter) {
        this.resetFilter();
      }
      const filteredResults = Object.fromEntries(
      // eslint-disable-next-line no-unused-vars
      Object.entries(fieldsList).filter(_ref => {
        let [key, val] = _ref;
        const matchesFilter = !filter || val.section.section === filter;
        const matchesSearch = !searchPhrase || val.label.toLowerCase().includes(searchPhrase.toLowerCase());
        return matchesFilter && matchesSearch;
      }));
      this.setState({
        filteredFieldsList: filteredResults
      });
    };
    this.handleSearch = (e, _ref2) => {
      let {
        value
      } = _ref2;
      this.setState({
        searchPhrase: value
      }, () => this.filter());
    };
    this.handleDomainFilter = (e, _ref3) => {
      let {
        value
      } = _ref3;
      this.setState({
        filter: value
      }, () => this.filter());
    };
    const {
      fieldsList: _fieldsList
    } = props;
    this.state = {
      filteredFieldsList: _fieldsList,
      searchPhrase: undefined,
      filter: undefined
    };
  }
  render() {
    const {
      filteredFieldsList
    } = this.state;
    const {
      alreadyAddedFields,
      fieldPath,
      handleSelectField,
      sections
    } = this.props;
    const dropdownOptions = sections.map(section => ({
      key: section,
      text: section,
      value: section
    }));
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Segment, {
      as: semanticUiReact.Modal.Content,
      attached: "bottom ml-0"
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      width: 10
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Input, {
      fluid: true,
      icon: "search",
      placeholder: "Search field names...",
      onChange: this.handleSearch
    })), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "flex align-items-center"
    }, "in:", " ", /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Dropdown, {
      className: "ml-5",
      fluid: true,
      inline: true,
      clearable: true,
      selection: true,
      placeholder: "All domains",
      options: dropdownOptions,
      onChange: this.handleDomainFilter
    }))))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Content, {
      scrolling: true
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Group, {
      divided: true,
      relaxed: true
    }, Object.entries(filteredFieldsList).map(_ref4 => {
      let [key, value] = _ref4;
      const names = key.split(":");
      const isDisabled = alreadyAddedFields.includes(`${fieldPath}.${key}`);
      return /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item, {
        key: key,
        className: isDisabled ? "pr-10 pl-10 disabled" : "clickable pr-10 pl-10",
        fieldName: key,
        field: filteredFieldsList[key],
        onClick: e => !isDisabled ? handleSelectField(e, key, value) : {}
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Content, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Header, {
        className: isDisabled ? "text-muted mb-5" : "mb-5"
      }, /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, value.label, " ", isDisabled && /*#__PURE__*/React__default["default"].createElement("span", {
        className: "right-floated"
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "checkmark",
        color: "green"
      }), " ", /*#__PURE__*/React__default["default"].createElement("span", null, " Added")))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Description, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Grid.Column, {
        width: 12
      }, value.note))), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Item.Extra, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: value.section.icon
      }), value.section.section, ": ", names[0]), value.multiple_values === true && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
        basic: true
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "list ol"
      }), " Multiple value field"), value.type === "text" && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
        basic: true
      }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
        name: "text cursor"
      }), " Text field"))));
    }), " ")));
  }
}
ListAndFilterCustomFields.defaultProps = {
  sections: undefined
};

/** Import function to load widget either from a specific path or local widgets
 *
 * The user defined path to import widget is of the format `@templates/<templatePath>`.
 * Note that the `@template` alias should be a correctly resolving path and it's the
 * user of this function that has to ensure that. The value is hardcoded here as the
 * dynamic import cannot rely on purely a dynamic path i.e a variable.
 */
async function importWidget(templateLoaders, _ref) {
  let {
    ui_widget: UIWidget,
    fieldPath,
    record,
    props
  } = _ref;
  let createElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let component = undefined;
  // Try import widget from user's defined templateLoaders
  for (const loader of templateLoaders) {
    try {
      var _module$default;
      const module = await loader(UIWidget);
      component = (_module$default = module.default) !== null && _module$default !== void 0 ? _module$default : module[UIWidget];
      // Component was found, stop looking.
      if (component) {
        break;
      }
    } catch (error) {
      // If the component failed to load from a loader, try other loaders first.
      continue;
    }
  }

  // Loading failed, log it and throw an error.
  if (component === undefined) {
    console.error(`Failed to import default component ${UIWidget}.js`);
    throw Error("Component not found in any loader");
  }
  if (createElement) {
    return /*#__PURE__*/React__default["default"].createElement(component, {
      ...props,
      record: record,
      key: fieldPath,
      fieldPath: fieldPath
    });
  } else {
    return component;
  }
}

/**
 * @param config: Configuration to load widgets
 *
 * Example configuration
 *
 * {
 *  fieldPathPrefix: "mynamespace" or empty,
 *  templateLoader: UIWidget => import(`my_folder/${UIWidget}.js`),
 *  fields: [{
 *    ui_widget: "MyWidget",
 *    field: "field_id",
 *    props: {
 *      label: "My label"
 *    }
 *  }]
 * }
 *
 * @returns array fields: resolved react components
 *
 * Example return
 *
 * [
 *  <Input fieldPath={'mynamespace.field_id'} label={label} />,
 *  ...
 * ]
 *
 */
async function loadWidgetsFromConfig(_ref2) {
  let {
    templateLoaders,
    fieldPathPrefix,
    fields,
    record
  } = _ref2;
  const importWidgetsFromFolder = (templateFolder, fieldPathPrefix, fieldsConfig) => {
    const tplPromises = [];
    fieldsConfig.forEach(fieldCfg => {
      tplPromises.push(importWidget(templateFolder, {
        ...fieldCfg,
        fieldPath: fieldPathPrefix ? `${fieldPathPrefix}.${fieldCfg.field}` : fieldCfg.field,
        record
      }));
    });
    return Promise.all(tplPromises);
  };
  const _fields = await importWidgetsFromFolder(templateLoaders, fieldPathPrefix, fields);
  return [..._fields];
}

// This file is part of Invenio-RDM-Records
class AddDiscoverableFieldsModal extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.handleModalOpen = () => {
      this.setState({
        modalOpen: true
      });
    };
    this.handleModalClosed = () => {
      this.setState({
        modalOpen: false
      });
    };
    this.handleSelectField = (e, fieldName, field) => {
      const {
        selectedFieldTarget: previousSelected
      } = this.state;
      if (previousSelected) {
        previousSelected.classList.toggle("selected-background");
      }
      e.currentTarget.classList.toggle("selected-background");
      const newField = {
        field: fieldName,
        props: {
          ...field
        },
        ui_widget: field.ui_widget
      };
      this.setState({
        selectedField: {
          ...newField
        },
        selectedFieldTarget: e.currentTarget
      });
    };
    this.handleAddField = async function () {
      let withClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      const {
        selectedField,
        addFields: prevFields,
        selectedFieldTarget,
        existingFields: prevExisting
      } = _this.state;
      const {
        fieldPath,
        templateLoaders,
        addFieldCallback
      } = _this.props;
      _this.setState({
        loading: true
      });
      selectedField["props"]["label"] = /*#__PURE__*/React__default["default"].createElement(RemoveField, {
        fieldPath: `${fieldPath}.${selectedField.field}`,
        removeFieldCallback: _this.handleRemoveField,
        field: {
          key: `${fieldPath}.${selectedField.field}`
        },
        label: selectedField.props.label
      });
      const field = await importWidget(templateLoaders, {
        ...selectedField,
        fieldPath: `${fieldPath}.${selectedField.field}`
      });
      const performCallback = () => {
        const {
          addFields
        } = _this.state;
        addFieldCallback(addFields);
        _this.setState({
          addFields: []
        });
        _this.handleModalClosed();
      };
      selectedFieldTarget.classList.toggle("selected-background");
      _this.setState({
        addFields: [...prevFields, field],
        existingFields: [...prevExisting, field.key],
        selectedField: undefined,
        selectedFieldTarget: undefined,
        loading: false
      }, () => withClose ? performCallback() : null);
    };
    this.handleCancel = () => {
      const {
        addFields
      } = this.state;
      const {
        addFieldCallback
      } = this.props;
      addFieldCallback(addFields);
      this.setState({
        addFields: []
      });
      this.handleModalClosed();
    };
    this.handleRemoveField = field => {
      const {
        existingFields: prevExisting
      } = this.state;
      const {
        removeFieldCallback
      } = this.props;
      const updatedFields = prevExisting.filter(n => field.key !== n);
      this.setState({
        existingFields: [...updatedFields]
      });
      removeFieldCallback(field);
    };
    const {
      existingFields
    } = props;
    this.state = {
      modalOpen: false,
      selectedField: undefined,
      selectedFieldTarget: undefined,
      addFields: [],
      existingFields: [...existingFields],
      loading: false
    };
  }
  render() {
    const {
      fieldPath,
      // injected by the custom field loader via the `field` config property
      icon,
      label,
      record,
      templateLoaders,
      addFieldCallback,
      removeFieldCallback,
      sections,
      existingFields: _,
      ...fieldsList
    } = this.props;
    const {
      modalOpen,
      existingFields,
      loading,
      selectedField
    } = this.state;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      icon: true,
      labelPosition: "left",
      onClick: this.handleModalOpen
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "plus"
    }), "Add field"), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal, {
      open: modalOpen
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Header, null, "Add domain specific fields"), /*#__PURE__*/React__default["default"].createElement(ListAndFilterCustomFields, {
      fieldPath: fieldPath,
      handleSelectField: this.handleSelectField,
      alreadyAddedFields: existingFields,
      fieldsList: fieldsList,
      sections: sections
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Modal.Actions, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      onClick: this.handleCancel,
      floated: "left",
      labelPosition: "left",
      content: "Close"
    }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      icon: true,
      labelPosition: "left",
      onClick: () => this.handleAddField(false),
      disabled: loading || !selectedField,
      loading: loading
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "plus"
    }), "Add field and continue"), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Button, {
      icon: true,
      labelPosition: "left",
      onClick: () => this.handleAddField(true),
      disabled: loading || !selectedField,
      loading: loading
    }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Icon, {
      name: "plus"
    }), "Add field and close"))));
  }
}
AddDiscoverableFieldsModal.defaultProps = {
  icon: undefined,
  label: undefined,
  sections: undefined
};

class DiscoverFieldsSection extends React.Component {
  constructor(_props) {
    super(_props);
    this.getFieldsConfig = sectionCfg => {
      const cfg = {};
      for (const section of sectionCfg) {
        for (const fieldCfg of section.fieldsConfig) {
          const {
            field,
            props,
            ui_widget,
            ...otherCfg
          } = fieldCfg;
          cfg[field] = {
            ui_widget: ui_widget,
            section: section,
            ...props,
            ...otherCfg
          };
        }
      }
      return cfg;
    };
    this.getFieldsWithValues = sectionFields => {
      const {
        tempFields,
        recordFields
      } = this.state;
      const filledFields = [];
      for (const field of sectionFields) {
        if (recordFields.includes(field.key) || tempFields.includes(field)) {
          filledFields.push(field);
        }
      }
      return filledFields;
    };
    this.getSectionOfField = field => {
      const {
        sections
      } = this.state;
      for (const section of sections) {
        if (section.fields.map(field => field.key).includes(field.key)) {
          return section.section;
        }
      }
    };
    this.addFieldCallback = fields => {
      const {
        sections: prevSections,
        tempFields: prevTempFields
      } = this.state;
      const sections = [...prevSections];
      for (const field of fields) {
        const sectionToUpdate = this.getSectionOfField(field);
        for (const section of sections) {
          if (section.section === sectionToUpdate) {
            section["fields"] = [...section.fields, field].sort((a, b) => a.key.localeCompare(b.key));
          }
        }
      }
      this.setState({
        sections: [...sections],
        tempFields: [...prevTempFields, ...fields]
      });
    };
    this.removeFieldCallback = field => {
      const {
        sections: prevSections,
        tempFields: prevTempFields
      } = this.state;
      const sections = [...prevSections];
      let tempFields = [...prevTempFields];
      const sectionToUpdate = this.getSectionOfField(field);
      for (const section of sections) {
        if (section.section === sectionToUpdate) {
          section["fields"] = section.fields.filter(n => field.key !== n.key);
          tempFields = tempFields.filter(n => field.key !== n.key);
        }
      }
      this.setState({
        sections: [...sections],
        tempFields: [...tempFields]
      });
    };
    const {
      sections: _sections,
      record
    } = _props; // sections = fields grouping, usually by domain
    console.warn(_props);
    let filled = [];
    if (record && !_isEmpty__default["default"](record.custom_fields)) {
      filled = Object.keys(record.custom_fields).map(key => `custom_fields.${key}`);
    }
    this.state = {
      sections: _sections,
      tempFields: [],
      recordFields: filled
    };
    this.fieldsCfg = this.getFieldsConfig(_sections);
    this.sectionsList = _sections.map(section => section.section);
  }
  render() {
    const {
      templateLoaders,
      record,
      discoverSectionLabel
    } = this.props;
    const {
      sections,
      tempFields,
      recordFields
    } = this.state;
    const existingFields = [...Object.entries(tempFields).map(_ref => {
      let [key, value] = _ref;
      return value.key;
    }), ...recordFields];
    const tempFieldsPaths = tempFields.map(item => item.key);
    return /*#__PURE__*/React__default["default"].createElement(AccordionField, {
      key: "discover-fields",
      includesPaths: tempFieldsPaths,
      label: discoverSectionLabel,
      active: true,
      id: "domain-specific-fields-section"
    }, sections.map(_ref2 => {
      let {
        fields,
        paths,
        ...sectionConfig
      } = _ref2;
      const recordCustomFields = this.getFieldsWithValues(fields);
      if (_isEmpty__default["default"](recordCustomFields)) {
        return undefined;
      }
      return /*#__PURE__*/React__default["default"].createElement("div", {
        key: sectionConfig.section,
        className: "rel-mb-2"
      }, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: sectionConfig.section,
        icon: sectionConfig.icon,
        label: sectionConfig.section
      }), /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Divider, {
        fitted: true,
        className: "rel-mb-1"
      }), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "rel-ml-1"
      }, recordCustomFields));
    }), /*#__PURE__*/React__default["default"].createElement(AddDiscoverableFieldsModal, Object.assign({
      fieldPath: "custom_fields"
    }, this.fieldsCfg, {
      templateLoaders: templateLoaders,
      addFieldCallback: this.addFieldCallback,
      removeFieldCallback: this.removeFieldCallback,
      sections: this.sectionsList,
      record: record,
      existingFields: existingFields
    })));
  }
}
DiscoverFieldsSection.defaultProps = {
  discoverSectionLabel: "Domain specific fields"
};
var DiscoverFieldsSection$1 = Overridable__default["default"].component("ReactInvenioForms.DiscoverFieldsSection", DiscoverFieldsSection);

// This file is part of React-Invenio-Forms
class CustomFields extends React.Component {
  constructor(props) {
    super(props);
    this.populateConfig = async () => {
      const {
        includesPaths,
        fieldPathPrefix
      } = this.props;
      try {
        const {
          sectionsConfig,
          discoverFieldsConfig
        } = await this.loadCustomFieldsWidgets();
        const sections = await Promise.all(sectionsConfig.map(async sectionCfg => {
          const paths = includesPaths(sectionCfg.fields, fieldPathPrefix);
          const widget = await this.loadSectionWidget(sectionCfg);
          return {
            ...sectionCfg,
            paths,
            widget
          };
        })).then(values => values);
        const discoverFieldsSections = discoverFieldsConfig.map(sectionCfg => {
          const paths = includesPaths(sectionCfg.fields, fieldPathPrefix);
          return {
            ...sectionCfg,
            paths
          };
        });
        this.setState({
          sections: sections,
          discoverFieldsSections: discoverFieldsSections
        });
      } catch (error) {
        console.error("Couldn't load custom fields widgets.", error);
      }
    };
    this.state = {
      sections: undefined,
      discoverFieldsSections: undefined
    };
  }
  componentDidMount() {
    this.populateConfig();
  }
  async loadSectionWidget(sectionCfg) {
    const {
      templateLoaders,
      record,
      includesPaths,
      fieldPathPrefix
    } = this.props;
    const paths = includesPaths(sectionCfg.fields, fieldPathPrefix);
    if (sectionCfg.ui_widget) {
      return await importWidget(templateLoaders, {
        ...sectionCfg,
        fieldPath: undefined,
        record,
        props: {
          includesPaths: paths,
          children: sectionCfg
        }
      }, false);
    }
  }
  async loadCustomFieldsWidgets() {
    const {
      config,
      fieldPathPrefix,
      templateLoaders,
      record
    } = this.props;
    const sections = [];
    const discoverFieldsSections = []; // finds sections with discoverable fields
    for (const sectionCfg of config) {
      // Path to end user's folder defining custom fields ui widgets
      const fields = await loadWidgetsFromConfig({
        templateLoaders: templateLoaders,
        fieldPathPrefix: fieldPathPrefix,
        fields: sectionCfg.fields,
        record: record
      });
      if (sectionCfg.discoverable_fields) {
        discoverFieldsSections.push({
          ...sectionCfg,
          fields: fields,
          fieldsConfig: sectionCfg.fields
        });
      } else {
        sections.push({
          ...sectionCfg,
          fields
        });
      }
    }
    return {
      sectionsConfig: sections,
      discoverFieldsConfig: discoverFieldsSections
    };
  }
  render() {
    const {
      sections,
      discoverFieldsSections
    } = this.state;
    const {
      templateLoaders,
      record
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, sections && sections.map(section => {
      const {
        fields,
        paths,
        displaySection = true,
        section: sectionName,
        widget,
        id: sectionId
      } = section;
      const active = section.active !== undefined ? section.active : true;
      const Element = widget !== undefined ? widget : AccordionField;
      return displaySection ? /*#__PURE__*/React__default["default"].createElement(Element, {
        key: `section-${sectionName}`,
        includesPaths: paths,
        label: sectionName,
        active: active,
        id: sectionId
      }, fields) : /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Container, {
        key: "custom-fields-section"
      }, fields);
    }), discoverFieldsSections && discoverFieldsSections.length > 0 && /*#__PURE__*/React__default["default"].createElement(DiscoverFieldsSection$1, {
      templateLoaders: templateLoaders,
      sections: discoverFieldsSections,
      record: record
    }));
  }
}
CustomFields.defaultProps = {
  includesPaths: fields => fields.map(field => field.key)
};

class SubjectAutocompleteDropdown extends React.Component {
  constructor() {
    super(...arguments);
    this.serializeSubjects = subjects => subjects.map(subject => {
      var _subject$id;
      const scheme = subject.scheme ? `(${subject.scheme}) ` : "";
      return {
        text: scheme + subject.subject,
        value: (_subject$id = subject.id) !== null && _subject$id !== void 0 ? _subject$id : subject.subject,
        key: subject.id,
        ...(subject.id ? {
          id: subject.id
        } : {}),
        subject: subject.subject
      };
    });
    this.prepareSuggest = searchQuery => {
      const {
        limitTo
      } = this.props;
      return limitTo === "" || limitTo === "all" ? searchQuery : `${limitTo}:${searchQuery}`;
    };
  }
  render() {
    const {
      fieldPath,
      required,
      multiple,
      placeholder,
      clearable,
      label,
      icon,
      width,
      allowAdditions,
      noQueryMessage,
      ...uiProps
    } = this.props;
    const labelContent = label ? /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
      htmlFor: fieldPath,
      icon: icon,
      label: label
    }) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: fieldPath,
      className: "mobile-hidden",
      "aria-label": "Placeholder label for alignment purposes"
    }, "\xA0"));
    return /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      name: fieldPath
    }, _ref => {
      let {
        form: {
          values
        }
      } = _ref;
      return /*#__PURE__*/React__default["default"].createElement(RemoteSelectField, Object.assign({}, uiProps, {
        clearable: clearable,
        fieldPath: fieldPath,
        initialSuggestions: formik.getIn(values, fieldPath, []),
        multiple: multiple,
        noQueryMessage: noQueryMessage,
        placeholder: placeholder,
        preSearchChange: this.prepareSuggest,
        required: required,
        serializeSuggestions: this.serializeSubjects,
        serializeAddedValue: value => ({
          text: value,
          value: value,
          key: value,
          subject: value
        }),
        suggestionAPIUrl: "/api/subjects",
        onValueChange: (_ref2, selectedSuggestions) => {
          let {
            formikProps
          } = _ref2;
          formikProps.form.setFieldValue(fieldPath, selectedSuggestions.map(subject => ({
            subject: subject.subject,
            id: subject.id
          })));
        },
        label: labelContent,
        value: formik.getIn(values, fieldPath, []).map(val => {
          var _val$id;
          return (_val$id = val.id) !== null && _val$id !== void 0 ? _val$id : val.subject;
        }),
        allowAdditions: allowAdditions,
        width: width
      }));
    });
  }
}
SubjectAutocompleteDropdown.defaultProps = {
  required: false,
  limitTo: "",
  label: "",
  icon: undefined,
  multiple: true,
  clearable: true,
  placeholder: "Search for a subject by name",
  width: undefined,
  noQueryMessage: "Search or create subjects...",
  allowAdditions: true
};

class AutocompleteDropdown extends React.Component {
  render() {
    const {
      description,
      fieldPath,
      required,
      label,
      icon,
      clearable,
      placeholder,
      multiple,
      autocompleteFrom,
      autocompleteFromAcceptHeader
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
      htmlFor: fieldPath,
      icon: icon,
      label: label
    }), /*#__PURE__*/React__default["default"].createElement(formik.Field, {
      name: fieldPath
    }, _ref => {
      let {
        form: {
          values
        }
      } = _ref;
      return /*#__PURE__*/React__default["default"].createElement(RemoteSelectField, {
        clearable: clearable,
        required: required,
        fieldPath: fieldPath,
        multiple: multiple,
        noQueryMessage: placeholder,
        placeholder: placeholder,
        suggestionAPIUrl: autocompleteFrom,
        suggestionAPIHeaders: {
          Accept: autocompleteFromAcceptHeader
        },
        serializeSuggestions: suggestions => {
          return _isArray__default["default"](suggestions) ? suggestions.map(item => ({
            text: item.title_l10n,
            value: item.id,
            key: item.id
          })) : [{
            text: suggestions.title_l10n,
            value: suggestions.id,
            key: suggestions.id
          }];
        },
        initialSuggestions: _get__default["default"](values, `ui.${fieldPath}`, [])
      });
    }), description && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, description));
  }
}
AutocompleteDropdown.defaultProps = {
  icon: undefined,
  autocompleteFromAcceptHeader: "application/vnd.inveniordm.v1+json",
  clearable: false,
  multiple: false,
  required: false
};

class Dropdown extends React.Component {
  constructor() {
    super(...arguments);
    this.serializeOptions = options => options === null || options === void 0 ? void 0 : options.map(option => ({
      text: option.title_l10n,
      value: option.id,
      key: option.id
    }));
  }
  render() {
    const {
      description,
      placeholder,
      fieldPath,
      label,
      icon,
      options,
      search,
      multiple,
      clearable,
      required
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(SelectField, {
      fieldPath: fieldPath,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: icon,
        label: label
      }),
      options: this.serializeOptions(options),
      search: search,
      "aria-label": label,
      multiple: multiple,
      placeholder: {
        role: "option",
        content: placeholder
      },
      clearable: clearable,
      required: required,
      optimized: true,
      defaultValue: multiple ? [] : ""
    }), description && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, description));
  }
}
Dropdown.defaultProps = {
  icon: undefined,
  search: false,
  multiple: false,
  clearable: true,
  required: false
};

class RichInput extends React.Component {
  render() {
    const {
      fieldPath,
      required,
      label,
      icon,
      description,
      editorConfig
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(RichInputField, {
      key: fieldPath,
      fieldPath: fieldPath,
      required: required,
      editorConfig: editorConfig,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: icon,
        label: label
      })
    }), description && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, description));
  }
}
RichInput.defaultProps = {
  icon: undefined,
  editorConfig: {},
  required: false
};

class TextArea extends React.Component {
  render() {
    const {
      fieldPath,
      required,
      label,
      icon,
      description,
      rows
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(TextAreaField, {
      key: fieldPath,
      fieldPath: fieldPath,
      required: required,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: icon,
        label: label
      }),
      rows: rows
    }), description && /*#__PURE__*/React__default["default"].createElement("label", {
      className: "helptext"
    }, description));
  }
}
TextArea.defaultProps = {
  icon: undefined,
  required: false,
  rows: 3
};

class Input extends React.Component {
  render() {
    const {
      fieldPath,
      required,
      label,
      icon,
      placeholder,
      description,
      disabled,
      type
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(TextField, {
      key: fieldPath,
      fieldPath: fieldPath,
      required: required,
      helpText: description,
      disabled: disabled,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: icon,
        label: label
      }),
      placeholder: placeholder,
      type: type
    });
  }
}
Input.defaultProps = {
  icon: undefined,
  required: false,
  disabled: false,
  type: "input"
};

function MultiInput(_ref) {
  let {
    additionLabel,
    description,
    placeholder,
    fieldPath,
    label,
    icon,
    required
  } = _ref;
  const [options, setOptions] = React.useState([]);
  const {
    values
  } = formik.useFormikContext();
  const serializeValues = values => values === null || values === void 0 ? void 0 : values.map(item => ({
    text: item,
    key: item,
    value: item
  }));
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(SelectField, {
    fieldPath: fieldPath,
    label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
      htmlFor: fieldPath,
      icon: icon,
      label: label
    }),
    options: serializeValues(formik.getIn(values, fieldPath, [])),
    placeholder: placeholder,
    required: required,
    search: true,
    multiple: true,
    clearable: true,
    optimized: true,
    defaultValue: [],
    noResultsMessage: placeholder // show the placeholder to instruct user how to add new values
    ,
    additionLabel: additionLabel,
    onChange: _ref2 => {
      let {
        data,
        formikProps
      } = _ref2;
      setOptions(serializeValues(data.value));
      formikProps.form.setFieldValue(fieldPath, data.value);
    },
    allowAdditions: true,
    onAddItem: _ref3 => {
      let {
        data
      } = _ref3;
      setOptions([{
        text: data.value,
        value: data.value
      }, ...options]);
    }
  }), description && /*#__PURE__*/React__default["default"].createElement("label", {
    className: "helptext"
  }, description));
}
MultiInput.defaultProps = {
  additionLabel: undefined,
  icon: undefined,
  required: false
};

const NumberInput = props => /*#__PURE__*/React__default["default"].createElement(Input, Object.assign({}, props, {
  type: "number"
}));

// This file is part of React-Invenio-Forms
function BooleanCheckbox(_ref) {
  let {
    description,
    icon,
    falseLabel,
    fieldPath,
    label,
    trueLabel,
    required
  } = _ref;
  // eslint-disable-next-line no-unused-vars
  const [_, meta] = formik.useField(fieldPath);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Group, {
    inline: true,
    className: "mb-0"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
    required: required
  }, /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
    htmlFor: fieldPath,
    icon: icon,
    label: label
  })), /*#__PURE__*/React__default["default"].createElement(RadioField, {
    fieldPath: fieldPath,
    label: trueLabel,
    checked: meta.value === true,
    value: true,
    optimized: true
  }), /*#__PURE__*/React__default["default"].createElement(RadioField, {
    fieldPath: fieldPath,
    label: falseLabel,
    checked: meta.value === false,
    value: false,
    optimized: true
  }), meta.error && /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Form.Field, {
    required: required,
    className: "error"
  }, /*#__PURE__*/React__default["default"].createElement(semanticUiReact.Label, {
    pointing: "left",
    prompt: true
  }, meta.error))), description && /*#__PURE__*/React__default["default"].createElement("label", {
    className: "helptext"
  }, description));
}
BooleanCheckbox.defaultProps = {
  icon: undefined,
  required: false
};

class Array$1 extends React.Component {
  render() {
    const {
      fieldPath,
      required,
      label,
      icon,
      description,
      disabled,
      children,
      addButtonLabel,
      defaultNewValue,
      className
    } = this.props;
    return /*#__PURE__*/React__default["default"].createElement(ArrayField, {
      key: fieldPath,
      fieldPath: fieldPath,
      required: required,
      helpText: description,
      disabled: disabled,
      label: /*#__PURE__*/React__default["default"].createElement(FieldLabel, {
        htmlFor: fieldPath,
        icon: icon,
        label: label
      }),
      addButtonLabel: addButtonLabel,
      defaultNewValue: defaultNewValue,
      className: className
    }, children);
  }
}
Array$1.defaultProps = {
  icon: undefined,
  required: false,
  disabled: false,
  className: ""
};

// This file is part of React-Invenio-Forms

/**
 * Make relative date for a given timestamp
 *
 * @param timestamp string ISO timestamp
 * @returns {string} relative date in a given language, f.e. 3 days ago
 */
const toRelativeTime = function (timestamp) {
  let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
  return luxon.DateTime.fromISO(timestamp).setLocale(language).toRelative();
};

exports.AccordionField = AccordionField;
exports.AffiliationsSuggestions = AffiliationsSuggestions;
exports.Array = Array$1;
exports.ArrayField = ArrayField;
exports.AutocompleteDropdown = AutocompleteDropdown;
exports.BaseForm = BaseForm;
exports.BooleanCheckbox = BooleanCheckbox;
exports.BooleanField = BooleanField;
exports.BulkActionsContext = BulkActionsContext;
exports.CustomFields = CustomFields;
exports.DiscoverFieldsSection = DiscoverFieldsSection$1;
exports.Dropdown = Dropdown;
exports.ErrorLabel = ErrorLabel;
exports.ErrorMessage = ErrorMessage;
exports.FeedbackLabel = FeedbackLabel;
exports.FieldLabel = FieldLabel;
exports.GridResponsiveSidebarColumn = GridResponsiveSidebarColumn;
exports.GroupField = GroupField;
exports.Image = Image;
exports.Input = Input;
exports.InvenioPopup = InvenioPopup;
exports.MultiInput = MultiInput;
exports.NumberInput = NumberInput;
exports.RadioField = RadioField;
exports.RemoteSelectField = RemoteSelectField;
exports.RichEditor = RichEditor;
exports.RichInput = RichInput;
exports.RichInputField = RichInputField;
exports.SearchResultsBulkActions = SearchResultsBulkActions;
exports.SearchResultsBulkActionsManager = SearchResultsBulkActionsManager;
exports.SearchResultsRowCheckbox = SearchResultsRowCheckbox;
exports.SelectField = SelectField;
exports.SubjectAutocompleteDropdown = SubjectAutocompleteDropdown;
exports.TextArea = TextArea;
exports.TextAreaField = TextAreaField;
exports.TextField = TextField;
exports.ToggleField = ToggleField;
exports.UserListItemCompact = UserListItemCompact;
exports.dropdownOptionsGenerator = dropdownOptionsGenerator;
exports.flattenAndCategorizeErrors = flattenAndCategorizeErrors;
exports.http = http;
exports.humanReadableBytes = humanReadableBytes;
exports.importWidget = importWidget;
exports.loadWidgetsFromConfig = loadWidgetsFromConfig;
exports.makeIdEntry = makeIdEntry;
exports.makeSubheader = makeSubheader;
exports.toRelativeTime = toRelativeTime;
exports.withCancel = withCancel;
//# sourceMappingURL=index.js.map
